/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResultsIndexRouteImport } from './routes/results/index'
import { Route as ResultsFacetRouteImport } from './routes/results/$facet'

const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsIndexRoute = ResultsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResultsRoute,
} as any)
const ResultsFacetRoute = ResultsFacetRouteImport.update({
  id: '/$facet',
  path: '/$facet',
  getParentRoute: () => ResultsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/results': typeof ResultsRouteWithChildren
  '/results/$facet': typeof ResultsFacetRoute
  '/results/': typeof ResultsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/results/$facet': typeof ResultsFacetRoute
  '/results': typeof ResultsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/results': typeof ResultsRouteWithChildren
  '/results/$facet': typeof ResultsFacetRoute
  '/results/': typeof ResultsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/results' | '/results/$facet' | '/results/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/results/$facet' | '/results'
  id: '__root__' | '/' | '/results' | '/results/$facet' | '/results/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ResultsRoute: typeof ResultsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results/': {
      id: '/results/'
      path: '/'
      fullPath: '/results/'
      preLoaderRoute: typeof ResultsIndexRouteImport
      parentRoute: typeof ResultsRoute
    }
    '/results/$facet': {
      id: '/results/$facet'
      path: '/$facet'
      fullPath: '/results/$facet'
      preLoaderRoute: typeof ResultsFacetRouteImport
      parentRoute: typeof ResultsRoute
    }
  }
}

interface ResultsRouteChildren {
  ResultsFacetRoute: typeof ResultsFacetRoute
  ResultsIndexRoute: typeof ResultsIndexRoute
}

const ResultsRouteChildren: ResultsRouteChildren = {
  ResultsFacetRoute: ResultsFacetRoute,
  ResultsIndexRoute: ResultsIndexRoute,
}

const ResultsRouteWithChildren =
  ResultsRoute._addFileChildren(ResultsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ResultsRoute: ResultsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
